import { render, staticRenderFns } from "./manageAgentIndex.pug?vue&type=template&id=6b6c2c46&scoped=true&lang=pug&"
import script from "./manageAgentIndex.ts?vue&type=script&lang=ts&"
export * from "./manageAgentIndex.ts?vue&type=script&lang=ts&"
import style0 from "./manageAgentIndex.scss?vue&type=style&index=0&id=6b6c2c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6c2c46",
  null
  
)

export default component.exports